import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { platformApi, formatApiError } from "@/lib/http";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ShieldCheck } from "lucide-react";

export default function PlatformLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await platformApi.post("/platform/login", { email, password });
      localStorage.setItem("azordi_platform_token", data.token);
      navigate("/platform");
    } catch (err) { setError(formatApiError(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-950 text-white p-4" data-testid="platform-login">
      <form onSubmit={submit} className="w-full max-w-sm bg-neutral-900 border border-neutral-800 rounded-2xl p-8 shadow-2xl">
        <div className="flex items-center gap-2 mb-1"><ShieldCheck className="h-6 w-6 text-emerald-400" /><span className="font-heading font-extrabold text-xl">Azordi Operations</span></div>
        <p className="text-neutral-400 text-sm mb-6">Platform administrator sign in</p>
        <label className="text-xs text-neutral-400">Email</label>
        <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" className="h-11 rounded-lg mb-3 mt-1 bg-neutral-800 border-neutral-700 text-white" data-testid="platform-email" />
        <label className="text-xs text-neutral-400">Password</label>
        <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" className="h-11 rounded-lg mb-4 mt-1 bg-neutral-800 border-neutral-700 text-white" data-testid="platform-password" />
        {error && <div className="text-sm text-red-400 mb-3" data-testid="platform-error">{error}</div>}
        <Button type="submit" disabled={loading} className="w-full h-11 rounded-lg bg-emerald-500 hover:bg-emerald-600 text-white" data-testid="platform-submit">{loading ? "Signing in…" : "Sign in"}</Button>
      </form>
    </div>
  );
}
